module.exports = "<div class=\"certificate-content\">\n  <iframe id=\"certificate-holder\" class=\"certificate-container\"></iframe>\n</div>\n<div class=\"row\">\n  <div class=\"centered-div\">\n    <button type=\"button\" (click)=\"onClick()\" class=\"btn btn-edcast-positive\">\n      Download\n    </button>\n  </div>\n  <div class=\"centered-div legend\">\n    {{ 'brandedPortal.certificate.download' | translate}}\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/content/certificate/preview/certificate-preview.component.html
// module id = 856
// module chunks = 0